import { useParams } from 'react-router-dom';
import { useApiToken } from 'lib/apiTokenKeeper';
import Api from 'domain/api';

const useCardThumbnailPath = ({ documentID }) => {
  // token is not passed to request directly however it is retrieved to refresh itself
  const token = useApiToken();
  const { companyId } = useParams();
  const params = {
    companyId,
    documentID,
  };

  return token ? Api.getDocumentThumbnailUrl(params) : null;
};

export default useCardThumbnailPath;
